export const TOKEN_ID_FIRST = '1';
export const TOKEN_ID_SECOND = '2';
